module.exports = __webpack_public_path__ + "static/media/all-country-flags.e06a069a.jpg";